/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_4_TitleInputs */

const en_privacy_section_4_title = /** @type {(inputs: Privacy_Section_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Cookies`)
};

const lv_privacy_section_4_title = /** @type {(inputs: Privacy_Section_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Sīkdatnes`)
};

/**
* | output |
* | --- |
* | "4. Cookies" |
*
* @param {Privacy_Section_4_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_4_title = /** @type {((inputs?: Privacy_Section_4_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_4_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_4_title(inputs)
	return en_privacy_section_4_title(inputs)
});